import { captureException } from "../error-tracking";

const isLoggerEnabled: boolean =
	process.env.NODE_ENV === "test" ||
	process.env.NODE_ENV === "development" ||
	import.meta.env.VITE_APP_TITLE === "dentLAB-dev_testing" ||
	import.meta.env.VITE_APP_TITLE === "dentCONNECT-dev_testing";

const isProduction: boolean =
	import.meta.env.VITE_APP_TITLE === "dentLAB" ||
	import.meta.env.VITE_APP_TITLE === "dentCONNECT";

export enum ErrorCategoryTag {
	XML = "xml",
	PDF = "pdf",
	DATABASE = "database",
	EXPORT_DOCUMENT_XML = "export-document-xml",
	EXPORT_DOCUMENT_PDF = "export-document-pdf",
}

type ErrorTags = {
	category?: ErrorCategoryTag;
	identifier?: string;
};

/**
 * Usage of Logger:
 * - .log -> standard logging
 * - .warn -> warning, no error tracking
 * - .error -> log as error and send to PostHog error tracking
 */
export class Logger {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	static log = (...params: any[]): void => {
		if (isLoggerEnabled) {
			// eslint-disable-next-line no-console
			console.log(...params);
		}
	};

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	static warn = (...params: any[]): void => {
		if (isLoggerEnabled) {
			console.warn(...params);
		}
	};

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	static error = (
		error: Error | string | any,
		tags?: ErrorTags,
		...params: any[]
	): void => {
		const normalizedError: Error =
			error instanceof Error ? error : new Error(String(error));

		captureException(normalizedError, tags);

		if (!isProduction) {
			// eslint-disable-next-line no-console
			console.error(error, tags, ...params);
		}
	};

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	static info = (...params: any[]): void => {
		if (isLoggerEnabled) {
			// eslint-disable-next-line no-console
			console.info(
				"%cINFO\n\n",
				"font-weight: bold; color: blue;",
				...params
			);
		}
	};
}
